var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot"},[_vm._v("大儒心理咨询中心备案号：京ICP备20031619号-1")])}
var staticRenderFns = []

export { render, staticRenderFns }